import { Link } from "react-router-dom";
import topics from "./topics";
import papers from "./papers";
import Subscribe from "./Subscribe";
import useTitle from "./useTitle";

const LEVEL = {
    s3: { title: "中三數學練習 S3 Math exercise PDF download", zh: "中三", h1: "S3 Math exercise Free PDF download", h1zh: "中三數學練習免費PDF下載" },
    s4: { title: "中四數學練習 S4 Math exercise PDF download", zh: "中四", h1: "S4 Math exercise Free PDF download", h1zh: "中四數學練習免費PDF下載" },
    s5: { title: "中五數學練習 S5 Math exercise PDF download", zh: "中五", h1: "S5 Math exercise Free PDF download", h1zh: "中五數學練習免費PDF下載" },
    s6: { title: "中六數學練習 S6 Math exercise PDF download", zh: "中六", h1: "S6 Math exercise Free PDF download", h1zh: "中六數學練習免費PDF下載" },
};

const LevelPage = ({ level }) => {
    const meta = LEVEL[level];
    const list = topics.filter((t) => t.level === level);
    useTitle(meta.title);

    return (
        <div className="paper-details">
            <h1>{meta.h1}</h1>
            <h1>{meta.h1zh}</h1>
            {/* the notes and exam papers pages, as cards: plain text links under the h1 were easy to miss */}
            <div className="level-quick">
                <Link to={`/${level}/notes`}>
                    <span className="q-title">{meta.zh}數學筆記</span>
                    <span className="q-sub">全部公式＋常犯錯誤，一版睇晒，可下載 PDF</span>
                    <span className="q-go">睇筆記 →</span>
                </Link>
                {papers.some((p) => p.level === level) && (
                    <Link to={`/${level}/papers`}>
                        <span className="q-title">{meta.zh}數學試卷連答案</span>
                        <span className="q-sub">學校考試格式，每題標分數，附答案同分數分配</span>
                        <span className="q-go">睇試卷 →</span>
                    </Link>
                )}
            </div>
            {/* public/pdf/<level>/<level>-math-ebook-*.pdf are every EX of the level merged; rebuild them whenever a chapter PDF changes */}
            <div className="level-ebook">
                <h2>{meta.zh}數學電子書 PDF</h2>
                <p>全級 {list.length} 個課題嘅 EX 合併成一本，每課附答案；有目錄同書籤，撳目錄就跳去嗰章。</p>
                <a href={`/pdf/${level}/${level}-math-ebook-chi.pdf`} target="_blank" rel="noreferrer">下載中文版</a>
                <a href={`/pdf/${level}/${level}-math-ebook-eng.pdf`} target="_blank" rel="noreferrer">Download English</a>
            </div>
            {list.map((t) => {
                const base = `/pdf/${level}/${level}-ch${t.ch}-${t.slug}-ex1-`;
                return (
                    <div className="paper-list" key={t.slug}>
                        <h2>
                            <Link to={`/${level}/${t.slug}`}>Ch {t.ch}: {t.en} {t.zh}</Link>
                        </h2>
                        <a href={`${base}eng.pdf`} target="_blank" rel="noreferrer">EX 1 (Eng)</a>
                        <a href={`${base}chi.pdf`} target="_blank" rel="noreferrer">EX 1 (中文版)</a>
                        <Link className="topic-link" to={`/${level}/${t.slug}`}>筆記與常犯錯誤 →</Link>
                    </div>
                );
            })}
            <Subscribe where={level} />
        </div>
    );
}

export default LevelPage;
